import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import Input from '@/common/components/Input';
import { SearchBarCenter } from '@/common/styles/SearchBars';
import { FiltersContainer } from './SpendsSearchBox.styled';

const SpendsSearchBox = ({ hook, onSearchClick }) => {
	return (
		<SearchBarCenter>
			<FiltersContainer>
				<Input
					name='Date for from'
					width={120}
					color={Colors.darkBlue}
					inputRef={hook.dateFromRef}
					type='date'
					value={hook.today}
					inputWidth={140}
					hasIncDec
				/>
				<Input
					name='Date for to'
					width={120}
					color={Colors.darkBlue}
					inputRef={hook.dateToRef}
					type='date'
					value={hook.today}
					inputWidth={140}
					hasIncDec
				/>
			</FiltersContainer>
			<ActionButton text='Search' onClick={() => onSearchClick()} />
		</SearchBarCenter>
	);
};

export default SpendsSearchBox;
